/**
 * @typedef {number} PlayerGroupId
 */

//-----------------------------------------------------------------------------

/** @type {PlayerGroupId} */
export const PLAYER_GROUP_ID_ALL    = 0; // Все игроки (обычные игроки и тестировщики).

/** @type {PlayerGroupId} */
export const PLAYER_GROUP_ID_QA     = 1; // Только тестировщики (не обычные игроки).

/** @type {PlayerGroupId} */
export const PLAYER_GROUP_ID_NORMAL = 2; // Только обычные игроки (не тестировщики).

//-----------------------------------------------------------------------------

export const DEFAULT_PLAYER_GROUP_ID = PLAYER_GROUP_ID_ALL;

/** @returns {PlayerGroupId[]} */
function getPlayerGroupIds() {
  return [
    PLAYER_GROUP_ID_ALL,
    PLAYER_GROUP_ID_QA,
    PLAYER_GROUP_ID_NORMAL
  ];
}

/**
 * @param {PlayerGroupId} playerGroupId
 * @returns {boolean}
 */
export function isPlayerGroupQA(playerGroupId) {
  return playerGroupId === PLAYER_GROUP_ID_QA;
}

/**
 * @param {PlayerGroupId} playerGroupId
 * @returns {string}
 */
export function getPlayerGroupName(playerGroupId) {
  switch(playerGroupId) {
    case PLAYER_GROUP_ID_ALL:    return 'all';
    case PLAYER_GROUP_ID_QA:     return 'QA';
    case PLAYER_GROUP_ID_NORMAL: return 'normal';
  }
  return `Unknown player group id ${playerGroupId}.`;
}

/**
 * @param {PlayerGroupId} playerGroupId
 * @returns {string}
 */
export function getPlayerGroupNameVerbose(playerGroupId) {
  switch(playerGroupId) {
    case PLAYER_GROUP_ID_ALL:    return 'all';
    case PLAYER_GROUP_ID_QA:     return 'QA';
    case PLAYER_GROUP_ID_NORMAL: return 'normal (all except QA)';
  }
  return `Unknown player group id ${playerGroupId}.`;
}

/**
 * Описание группы для показа на странице со всеми событиями.
 * @param {PlayerGroupId} playerGroupId
 * @returns {?string}
 */
export function getPlayerGroupDescription(playerGroupId) {
  if(playerGroupId === PLAYER_GROUP_ID_NORMAL) {
    return 'Normal players (all players except QA)';
  }
  return null;
}

/**
 * @typedef {Object} PlayerGroupOption
 * @property {PlayerGroupId} value
 * @property {string} text
 */

/**
 * Options for component b-form-select.
 * @returns {PlayerGroupOption[]}
 */
export function getPlayerGroupOptions() {
  const options = [];
  
  const groupIds = getPlayerGroupIds();
  for(const groupId of groupIds) {
    const option = {
      value: groupId,
      text: getPlayerGroupName(groupId),
    };
    options.push(option);
  }
  
  return options;
}

/**
 * Options for component b-form-select.
 * @returns {PlayerGroupOption[]}
 */
export function getPlayerGroupOptionsVerbose() {
  const options = [];
  
  const playerGroupIds = getPlayerGroupIds();
  for(const playerGroupId of playerGroupIds) {
    const option = {
      value: playerGroupId,
      text: getPlayerGroupNameVerbose(playerGroupId),
    };
    options.push(option);
  }
  
  return options;
}

//-----------------------------------------------------------------------------

/**
 * @typedef {number} PlayerGroupPublicity
 */
const PLAYER_GROUP_PUBLICITY_QA     = 1;
const PLAYER_GROUP_PUBLICITY_PUBLIC = 2;

/**
 * @param {PlayerGroupId} playerGroupId
 * @returns {PlayerGroupPublicity}
 */
export function getPlayerGroupPublicity(playerGroupId) {
  if(isPlayerGroupQA(playerGroupId)) {
    return PLAYER_GROUP_PUBLICITY_QA;
  }
  return PLAYER_GROUP_PUBLICITY_PUBLIC;
}

/**
 * @param {PlayerGroupPublicity} publicity
 * @returns {string}
 */
export function getPlayerGroupPublicityName(publicity) {
    switch(publicity) {
    case PLAYER_GROUP_PUBLICITY_QA:     return 'QA';
    case PLAYER_GROUP_PUBLICITY_PUBLIC: return 'public';
  }
  return `Unknown publicity ${publicity}.`;
}
